// extracted by mini-css-extract-plugin
module.exports = {"productConfiguration":"styles__productConfiguration___Ke9Uk","componentTitle":"styles__componentTitle___32cW7"};